/* ==========================================================================
   Carousel > Prototype
   ========================================================================== */

/* Modules */
const Swiper = require('swiper/dist/js/swiper');

const config = require('./vendor/config');

const { resizeWindow } = require('../../../../events/resize');

/* Set the multi carousel */
function setMultiCarousel(instance) {
    const result = {};
    const selectorClass = `js-${instance.id}`;

    /* Add the custom classes to navigation */
    if (instance.config.hasNavigation) {
        result.navigation = {};
        result.navigation.prevEl = `${instance.swiper.navigation.prevEl}.${selectorClass}`;
        result.navigation.nextEl = `${instance.swiper.navigation.nextEl}.${selectorClass}`;

        instance.element.parentNode
            .querySelectorAll('.carousel__navigation')
            .forEach(item => item.classList.add(selectorClass));
    }

    /* Add the custom classes to pagination */
    if (instance.config.hasPagination) {
        result.pagination = {};
        result.pagination.el = `${instance.swiper.pagination.el}.${selectorClass}`;

        instance.element.parentNode.querySelector('.carousel__pagination').classList.add(selectorClass);
    }

    return result;
}

const checkHasNavigation = (hasNavigation, instance) => {
    const panel = instance;
    if (hasNavigation) {
        panel.swiper.navigation = { ...instance.swiper.navigation, ...setMultiCarousel(instance).navigation };
        return;
    }
    panel.swiper.navigation = {};
};

const checkHasPagination = (hasPagination, instance) => {
    const panel = instance;
    if (hasPagination) {
        panel.swiper.pagination = { ...instance.swiper.pagination, ...setMultiCarousel(instance).pagination };
        return;
    }
    panel.swiper.pagination = {};
};

const carousel = {
    /* Update swiper view */
    update() {
        this.swiper.update();

        return this;
    },
    /* Add 3rd party library config to the instance config */
    setConfig() {
        /* compose config for 3rd party library */
        const baseConfig = config(this.config);
        this.swiper = { ...baseConfig, ...this.config.swiper };

        return this;
    },
    /* Append slide */
    appendSlide(content = '') {
        if (!content) return this;

        this.swiper.appendSlide(`<div class="${this.config.css.slide}">${content}</div>`);

        return this;
    },
    /* Init */
    init() {
        /* Set the 3rd party library config */
        this.setConfig();

        /* Set the multicarousel */
        if (this.config.isMulti) {
            checkHasNavigation(this.config.hasNavigation, this);

            checkHasPagination(this.config.hasPagination, this);
        }

        /* Create 3rd party library choices instance */
        this.swiper = new Swiper(this.element, this.swiper);

        /* Set auto resize */
        const { autoResize = true } = this.config;

        if (autoResize) {
            resizeWindow(250);
        }
    }
};

module.exports = carousel;
